import { render, staticRenderFns } from "./closeTaskItemDialog.vue?vue&type=template&id=220cf1fa&scoped=true"
import script from "./closeTaskItemDialog.vue?vue&type=script&lang=js"
export * from "./closeTaskItemDialog.vue?vue&type=script&lang=js"
import style0 from "./closeTaskItemDialog.vue?vue&type=style&index=0&id=220cf1fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220cf1fa",
  null
  
)

export default component.exports